import { GrafikCercevesi } from "./GrafikCercevesi";
import { kisalt, olculen, sayiMetni } from "./hesap";
import type { GrafikDegeri, GrafikOrtakProps } from "./tipler";

export interface HalkaProps extends Omit<GrafikOrtakProps, "birim"> {
  /** 0–100 arası yüzde; oran verisi için çağıran 100 ile çarpar. */
  deger: GrafikDegeri;
}

export function Halka({ baslik, deger, ozet, bosMesaji }: HalkaProps) {
  const yuzde = olculen(deger);
  const doluluk = Math.min(100, yuzde ?? 0);
  const metin = sayiMetni(yuzde, "%");
  const ozetMetni = ozet?.trim() || `${baslik}: ${metin} tamamlandı.`;
  return (
    <GrafikCercevesi
      baslik={baslik}
      ozet={ozetMetni}
      bos={yuzde === null}
      bosMesaji={bosMesaji}
      basliklar={["Tamamlanma"]}
      satirlar={[{ anahtar: "yuzde", etiket: baslik, hucreler: [metin] }]}
    >
      <svg
        role="img"
        aria-label={ozetMetni}
        viewBox="0 0 180 180"
        width="100%"
        style={{ display: "block", height: "auto", maxWidth: 220 }}
      >
        <title>{ozetMetni}</title>
        <circle
          cx="90"
          cy="90"
          r="64"
          fill="none"
          stroke="var(--color-notr-200)"
          strokeWidth="16"
        />
        <circle
          data-testid="halka-dolgu"
          cx="90"
          cy="90"
          r="64"
          fill="none"
          stroke="var(--color-marka-600)"
          strokeWidth="16"
          pathLength="100"
          strokeDasharray={`${doluluk} ${100 - doluluk}`}
          transform="rotate(-90 90 90)"
        />
        <text
          x="90"
          y="94"
          textAnchor="middle"
          fontSize="24"
          fontWeight="600"
          fill="var(--color-notr-900)"
        >
          <title>{metin}</title>
          {kisalt(metin, 10)}
        </text>
        <text x="90" y="116" textAnchor="middle" fontSize="12" fill="var(--color-notr-600)">
          tamamlandı
        </text>
      </svg>
      {yuzde !== null && yuzde > 100 && (
        <p className="text-notr-600 text-sm">Ölçüm %100'ü aşıyor; halka tam dolu gösterilir.</p>
      )}
    </GrafikCercevesi>
  );
}
